export default __webpack_public_path__ + "static/media/acall.fa27865e.svg";